import { HospitalizationType } from 'common/enum/hospitalization-type'
import {
  CidV2Props,
  ClinicalHistoryFormValues,
  CooperativeV2Props,
  HealthInsuranceV2Props,
  LocationV2Props,
  OpmeV2Props,
  PatientV2Props,
  ProcedureV2Props,
  ProviderV2Props,
  SurgicalOrderV2Props
} from './types'
import { Techniques } from 'common/enum/techniques'
import { MaritalStatus } from 'presentation/utils/default-marital-status'

export const INITIAL_LOCATION: LocationV2Props = {
  hospital: {
    hospitalId: 0,
    hospitalName: ''
  },
  surgical_center: {
    surgeryCenterId: 0,
    surgeryCenterName: ''
  }
}

export const INITIAL_PATIENT: PatientV2Props = {
  cpf: '',
  name: '',
  birthDate: '',
  gender: '',
  maritalStatus: undefined as MaritalStatus | undefined,
  phone: '',
  email: '',
  isNewPatient: false,
  internation: undefined,
  tutor: {
    cpf: '',
    name: '',
    phone: '',
    email: ''
  }
}

export const INITIAL_HEALTH_INSURANCE: HealthInsuranceV2Props = {
  healthInsuranceId: 0,
  healthInsuranceCode: 0,
  healthInsuranceName: '',
  healthCard: '',
  validThru: '',
  healthPlanCode: 0,
  healthPlanName: '',
  healthSubplanCode: 0,
  healthSubplanName: '',
  companyName: ''
}

export const INITIAL_COOPERATIVE: CooperativeV2Props = {
  cooperative: ''
}

export const COOPERATIVE_HOSPITALS = [
  8, // SALVADOR
  22 // EMEC
]

export const INITIAL_CLINICAL_HISTORY: ClinicalHistoryFormValues = {
  clinicalHistoryDescription: '',
  clinicalHistoryAspects: '',
  clinicalHistoryLatexAllergy: '',
  clinicalHistoryOtherAllergy: '',
  clinicalHistoryOncology: undefined,
  clinicalHistoryBloodTransfusion: undefined,
  clinicalHistoryTechnique: '' as Techniques,
  clinicalHistoryCongelation: undefined,
  clinicalHistoryBloodReserve: undefined,
  clinicalHistoryHospitalized: undefined,
  clinicalHistoryExpectedDate: null,
  clinicalHistoryBullishForecastDate: null,
  clinicalHistoryHospitalizationType: '' as HospitalizationType,
  clinicalHistoryHospitalizationMode: '',
  clinicalHistoryHospitalizationDailyQuantity: 1,
  clinicalHistoryCti: undefined,
  clinicalHistoryMedicalObservations: ''
}

export const INITIAL_PROCEDURES: ProcedureV2Props[] = []

export const INITIAL_PROVIDERS: ProviderV2Props[] = []

export const INITIAL_OPMES: OpmeV2Props[] = []

export const INITIAL_CIDS: CidV2Props[] = []

export const INITIAL_SURGICAL_ORDER: SurgicalOrderV2Props = {
  surgicalOrderId: 0,
  orderWasLoadedInContext: false,
  finalizedSurgicalOrderId: 0,
  documents: [],
  reportRecommendation: ''
}
